import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { RootState } from "@/store";

const AdminProtectedRoute = () => {
  const admin = useSelector((state: RootState) => state.rootReducer.adminReducer.admin);    
  const localAdmin = JSON.parse(localStorage.getItem("admin") || "null");

  // Optional fallback if Redux is not yet synced
  const isAdminAuthenticated = admin || localAdmin;

  if (!isAdminAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
